import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'

@Component({
    selector: 'case-color-yield',
    templateUrl: './color-yield.component.html',
    styleUrls: ['./color-yield.component.scss'],
    imports: [CommonModule],
    standalone: true
})
export class ColorYieldComponent {
  @Input() color: string
  @Input() text?: string
}
